import { combineReducers } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import modalReducer from './slices/modalSlice';

const rootReducer = combineReducers({
    ui: uiReducer,
    modal: modalReducer,
});

export default rootReducer;
